import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import { selectSelectedLeague } from "@features/leaguemgmt/leagueManagementSlice";

import { useAppSelector } from "@hooks/reduxHooks";

import Standings from "@Leagues/components/Standings";

const League = (): React.JSX.Element => {
    const league = useAppSelector(selectSelectedLeague);

    return (
        <div data-testid="leagueContent">
            <Container className="league py-2 py-lg-0" fluid="xs">
                <Row>
                    <Col>
                        <h2>Standings</h2>
                        <Standings data={league} expanded bordered />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default League;
